<template>
 <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <div class="row justify-between tw-gap-4 ">
        <div class="col-auto">
          <div v-html="vars.titleHtml"> </div>
        </div>

        <div class="col-xl-6 ">
          <p class="">
            {{ vars.descriptionText }}
          </p>
        </div>
      </div>
      </div>
      </section>

  
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';


export default defineNuxtComponent({
  name: 'TakeAction',

 

  mixins: [ComponentMixin],

  

  
});
</script>


